
import { defineComponent } from "vue";

export default defineComponent({
  name: "SelectAll",

  components: {},

  props: {
    checked: {
      type: Boolean,
    },
  },

  emits: ["change"],

  methods: {
    onChange($event: Event) {
      const isChecked = ($event.target as HTMLInputElement).checked;
      this.$emit("change", isChecked);
    },
  },
});
